import { forwardRef, MouseEventHandler, ReactNode } from 'react';

import Box, { BoxProps } from '@o2/ui/Box';
import IconButton from '@o2/ui/IconButton';
import Stack from '@o2/ui/Stack';
import TrashBin from '@o2/icons/TrashBin';

interface ItemProps extends BoxProps {
  children?: ReactNode;
  onRemove?: MouseEventHandler;
}

const Item = forwardRef<HTMLDivElement, ItemProps>(({ children, onRemove, ...props }, ref) => {
  return (
    <Stack direction="row" {...props} ref={ref} px={1} py={1.5} alignItems="center">
      <Box flexGrow={1}>{children}</Box>
      {onRemove && (
        <IconButton onClick={onRemove} variant="squared">
          <TrashBin />
        </IconButton>
      )}
    </Stack>
  );
});

Item.displayName = 'List.Item';

export default Item;
